import { dashboardConstants } from '../constants';

const initialState = {
	locals: [],
	businessUnits: [],
	occupationArea: [],
  statusIdeaCode: [],
	statusChallengeCode: [],
	loading: false,
	csvBase64: "",
}

export function dashboard(state = initialState, action) {
  switch (action.type) {

    case dashboardConstants.GET_DASHBOARD_CSV_REQUEST: {
			return { 
				...state,
				loading: true
			}
		}

		case dashboardConstants.GET_DASHBOARD_CSV_SUCCESS: {
			return { 
				...state,
				loading: false,
				csvBase64: action.payload
			}
		}

		case dashboardConstants.GET_DASHBOARD_CSV_FAILURE: {
			return { 
				...state,
				loading: false
			}
		}

		default:
      return state;

  }
}